import {Component, Input, ViewChild} from '@angular/core';
import {DatePickerComponent} from '@progress/kendo-angular-dateinputs';

import {BoiteDialogueGeneriqueComponent, SimpleLibelleComponent, SimplePanelComponent} from "../../../../val-composants-lib/src/public-api";

//Composant boîte de dialogue RG date
@Component (
{
  selector: 'val-boite-dialogue-rg-date',
  imports: 
  [
    BoiteDialogueGeneriqueComponent,
    SimpleLibelleComponent,
    SimplePanelComponent,
    DatePickerComponent
  ],
  templateUrl: './boite-dialogue-rg-date.component.html',
  styleUrl: './boite-dialogue-rg-date.component.scss'
})
export class BoiteDialogueRgDateComponent 
{
  //Création
  constructor () 
  {
    this.bandeau = "";
    this.titre = "";
    this.date = null;
  }

  //Boîte de dialogue
  @ViewChild ("boiteDialogue")
  public boiteDialogue!: BoiteDialogueGeneriqueComponent<Date | null>;

  //Titre
  @Input ()
  public titre: string;

  //Bandeau
  @Input ()
  public bandeau: string;

  //Date
  public date: Date | null;

  //Ouvre la boîte de dialogue
  //  Retourne
  //    Date
  public async Ouvrir () : Promise<Date | null> 
  {
    let operation: Promise<Date | null>;

    operation = this.boiteDialogue.Ouvrir ();

    return operation;
  }

  //Valide la saisie
  public Valider () : void 
  {
    this.boiteDialogue.fonctionRetour (this.date);
    this.boiteDialogue.Fermer ();
  }

  //Annule la saisie
  public Annuler () : void 
  {
    this.boiteDialogue.fonctionRetour (null);
    this.boiteDialogue.Fermer ();
  }
}
